// extracted by mini-css-extract-plugin
module.exports = {"logo":"Origin_logo__3ZMC1","base":"Origin_base__2U4qs","rain":"Origin_rain__11WIO"};